// API base URL
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// Auth endpoints
export const LOGIN_ENDPOINT = '/auth/login';
export const REFRESH_ENDPOINT = '/auth/refresh';

// Event endpoints
export const EVENTS_ENDPOINT = '/eventopia/events';
export const SEARCH_EVENTS_ENDPOINT = '/eventopia/search/events';

// Venue endpoints
export const VENUES_ENDPOINT = '/eventopia/venues';

// Contact endpoints
export const CONTACTS_ENDPOINT = '/eventopia/contacts';
export const CONTACT_LISTS_ENDPOINT = '/eventopia/contacts/lists'; 